import {
  MonitoringActivationLogList,
  type MonitoringActivationEvent,
} from './MonitoringActivationLogList';

export type AssuntoMonitoringActivationEvent = MonitoringActivationEvent;

interface AssuntoMonitoringActivationLogListProps {
  history: MonitoringActivationEvent[];
  loading?: boolean;
  isMonitored?: boolean;
  assuntoLabel?: string | null;
}

/** Wrapper de compatibilidade — use MonitoringActivationLogList para novos fluxos. */
export function AssuntoMonitoringActivationLogList({
  history,
  loading = false,
  isMonitored,
  assuntoLabel,
}: AssuntoMonitoringActivationLogListProps) {
  return (
    <MonitoringActivationLogList
      history={history}
      loading={loading}
      isActive={isMonitored}
      activeEntityLabel={assuntoLabel}
      activeStatusMessage={
        isMonitored && assuntoLabel ? `Assunto «${assuntoLabel}» está ativo no momento.` : null
      }
    />
  );
}
